import apiClient from '@/config/api';

const RESOURCE = '/reports';

const cfg = () => ({
    headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
});

export default {
    getSummary({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/summary`, cfg())
                .then(res => { commit('SET_SUMMARY', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getPropertiesByType({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/properties-by-type`, cfg())
                .then(res => { commit('SET_PROPERTIES_BY_TYPE', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getPropertiesByObjective({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/properties-by-objective`, cfg())
                .then(res => { commit('SET_PROPERTIES_BY_OBJECTIVE', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getPropertiesByCondition({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/properties-by-condition`, cfg())
                .then(res => { commit('SET_PROPERTIES_BY_CONDITION', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getPropertiesByLocation({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/properties-by-location`, cfg())
                .then(res => { commit('SET_PROPERTIES_BY_LOCATION', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getTopProperties({ commit }, limit = 10) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/top-properties?limit=${limit}`, cfg())
                .then(res => { commit('SET_TOP_PROPERTIES', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getPriceAnalytics({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/price-analytics`, cfg())
                .then(res => { commit('SET_PRICE_ANALYTICS', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getAgentPerformance({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/agent-performance`, cfg())
                .then(res => { commit('SET_AGENT_PERFORMANCE', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getMonthlyActivity({ commit }, months = 12) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/monthly-activity?months=${months}`, cfg())
                .then(res => { commit('SET_MONTHLY_ACTIVITY', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
    getMySummary({ commit }) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/my-summary`, cfg())
                .then(res => { commit('SET_MY_SUMMARY', res.data.data); resolve(res.data.data); })
                .catch(err => reject(err));
        });
    },
}
